export default "__VITE_ASSET__BEB7yQ0e__"